import useAppModernisation from "../../hooks/useAppModernisation";
import Search from "../search/search";
import EnhancedSearchResultsPage from "./EnhancedSearchResultsPage"; 
import EnhancedSearchResultsPageApp from "./EnhancedSearchResultsPageApp";
const SearchRouter = () => {
  const { isEnhancedSearchEnabled, isAppMode } = useAppModernisation();
  return isEnhancedSearchEnabled ? (
    isAppMode ? (
      <EnhancedSearchResultsPageApp />
    ) : (
      <EnhancedSearchResultsPage />
    )
  ) : (
    <Search />
  );
};

export default SearchRouter;